import styled from "styled-components";

export const FooterCopyright = styled.div`
  text-align: center;
  /* padding: 20px; */
  color: #333;
  background: #999 url("/images/footer_bg.png") no-repeat center center;
  background-size: cover;
  border-top: 1px solid #ddd;
  margin-top: auto;
  height: 53px;
  width: 100%;
  position: absolute;
  line-height: 50px;
  font-size: 14px;

  a {
    color: #3366ff;
  }
`;
